import React from 'react';
const photos = [{
  url: 'https://cdn.magicpatterns.com/uploads/dSAFhrFoUNRdwdizL2ov7E/michael-smith-bsld7GjQwjI-unsplash.jpg',
  label: 'Full-Service Lawn Maintenance'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/kyDsPDx3wFxemws8WLWdPk/daniel-watson-8vBpYpTGo90-unsplash.jpg',
  label: 'Precision Mowing'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/icG1ddDbmmYphffX2Bctfq/tile-merchant-ireland-wd3L9AMXcUU-unsplash.jpg',
  label: 'Paver Patio & Outdoor Living'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/qUSbf6N3y9ig24ERXeXuuL/ashley-diane-worsham-RMLJ6KF1Zfk-unsplash.jpg',
  label: 'Tree & Bed Planting'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/hR8QHpCxKqgxkxo9Q2rEHp/fraem-gmbh-rBY5Ek86oOI-unsplash.jpg',
  label: 'Hedge Trimming & Pruning'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/hjP4NUhJZHMb3yy3tMbALR/kenny-perez-KX53yD2tjec-unsplash.jpg',
  label: 'Curb Appeal Edging'
}];
export function Gallery() {
  return <section id="work" className="py-20 md:py-28 bg-gray-50" data-id="element-60">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-61">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-62">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 mb-4 inline-block relative" data-id="element-63">
            Our Work Speaks for Itself
            <span className="absolute -bottom-2 left-1/4 right-1/4 h-1 bg-brand rounded-full" data-id="element-64"></span>
          </h2>
          <p className="text-lg text-gray-600 mt-6" data-id="element-65">
            Real yards, real results. Right here in Denton.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-66">
          {photos.map((photo, index) => <div key={index} className="group relative rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 aspect-[4/3]" data-id="element-67">
              <img src={photo.url} alt={photo.label} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-68" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end" data-id="element-69">
                <div className="p-6 w-full" data-id="element-70">
                  <p className="text-white font-semibold text-lg" data-id="element-71">
                    {photo.label}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-72">
          <a href="#portfolio" className="inline-flex items-center justify-center border-2 border-brand text-brand hover:bg-brand hover:text-white font-semibold py-4 px-8 rounded-xl transition-colors min-h-[48px] text-lg w-full sm:w-auto" data-id="element-73">
            View Full Portfolio
          </a>
        </div>
      </div>
    </section>;
}